import type { AcLineSegmentResult } from '../../../..';
import type { AcLineEvaluatedLoading } from '../../../../derived-state/loadFlowSummary';
import { NumbersRange } from '../../../../domain/NumbersRange';
import { Messenger } from '../../../AttentionStatusRepository';
import type { ForAcLineSegmentEvaluation } from './forAcLineSegmentEvaluation';

export class AcLineSegmentSummaryEvaluation {
  private acLineSegmentResults: AcLineSegmentResult[];
  private evaluationEngine: ForAcLineSegmentEvaluation;

  constructor(
    busbarResults: AcLineSegmentResult[],
    evaluationEngine: ForAcLineSegmentEvaluation
  ) {
    this.acLineSegmentResults = busbarResults;
    this.evaluationEngine = evaluationEngine;
  }

  evaluateLoadingPercents(): AcLineEvaluatedLoading {
    const voltages = this.acLineSegmentResults.map(e => e.loadingPercent);

    const voltageRange = new NumbersRange(voltages);
    const min = this.evaluationEngine.evaluateLoadingPercent(
      voltageRange.min,
      Messenger.notDelegated()
    );
    const max = this.evaluationEngine.evaluateLoadingPercent(
      voltageRange.max,
      Messenger.notDelegated()
    );

    return { min, max };
  }
}
